import * as Mobx from 'mobx'
import mobxFormatters from 'mobx-formatters'

mobxFormatters(Mobx)


// WEBPACK FOOTER //
// ./src/utils/mobxFormatter.js